import React, { FC } from 'react';
import styles from './Tabs.module.scss';
import { Tabs as AntTabs, TabsProps } from 'antd';
import { twMerge } from '@shared/utils/twMerge';

type TabsExtraProps = { blocked?: boolean, mode?: 'underline' | 'button' };

export const Tabs: FC<TabsProps & TabsExtraProps> = props => {
  const { blocked, className = '', mode = 'underline', ...properties } = props;
  const items = props.items?.map(item => ({
    ...item,
    disabled: blocked || item?.disabled,
  }));

  const currentStyles = mode === 'button' ? styles.button : styles.underline;
  return (
    <AntTabs
      { ...properties }
      items={ items }
      className={ twMerge(blocked && styles.blocked, currentStyles, className) }
    />
  );
};
